import { combineReducers } from 'redux';
import taxInvoiceReducer from './taxInvoiceReducer';
import taxBookReducer from './taxBookReducer';
import lookupReducer from './lookupReducer';
import vatInfoReducer from './vatInfoReducer';
import settingsReducer from './settingsReducer';
import auditLogReducer from './auditLogReducer';

const taxInvoiceReducers = combineReducers({
  taxInvoice: taxInvoiceReducer,
  taxBook: taxBookReducer,
  lookup: lookupReducer,
  vatInfo: vatInfoReducer,
  settings: settingsReducer,
  auditLog: auditLogReducer,
});

export default taxInvoiceReducers;
